import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { UiModule } from "../shared/ui/ui.module";
import { WidgetModule } from "../shared/widget/widget.module";

import { PagesRoutingModule } from "./pages-routing.module";

import {
  NgbNavModule,
  NgbDropdownModule,
  NgbTooltipModule,
  NgbCollapseModule,
} from "@ng-bootstrap/ng-bootstrap";
import { NgApexchartsModule } from "ng-apexcharts";
import { Ng2SearchPipeModule } from "ng2-search-filter";
import { FullCalendarModule } from "@fullcalendar/angular";
import { DndModule } from "ngx-drag-drop";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { LeafletModule } from "@asymmetrik/ngx-leaflet";

import { DashboardComponent } from "./dashboard/dashboard.component";
import { CalendarComponent } from "./calendar/calendar.component";
import { ChatComponent } from "./chat/chat.component";
import { EcommerceModule } from "./ecommerce/ecommerce.module";
import { KanbanComponent } from "./kanban/kanban.component";
import { EmailModule } from "./email/email.module";
import { UIModule } from "./ui/ui.module";
import { IconsModule } from "./icons/icons.module";
import { ChartModule } from "./chart/chart.module";
import { FormModule } from "./form/form.module";
import { TablesModule } from "./tables/tables.module";
import { MapsModule } from "./maps/maps.module";
import { DashboardService } from "../services/dashboard.service";
import { VehiclesComponent } from "./customer-mgmt/vehicle/vehicles/vehicles.component";
import { AlertModule, AlertService } from "ngx-alerts";
import { TripsComponent } from "./customer-mgmt/trips/trips.component";
import { MatPaginatorModule } from "@angular/material/paginator";
import { DrivingAlertsComponent } from "./customer-mgmt/vehicle/driving-alerts/driving-alerts.component";
import { VehicleTroubleCodesComponent } from "./customer-mgmt/vehicle/vehicle-trouble-codes/vehicle-trouble-codes.component";
import { AlertCustomersComponent } from "./customer-mgmt/alert-customers/alert-customers.component";
import { RemindersUsersComponent } from "./customer-mgmt/reminders-users/reminders-users.component";
import { TeamUsersComponent } from "./customer-mgmt/team-users/team-users.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { AddUpdateTeamUserComponent } from "./customer-mgmt/team-users/add-update-team-user/add-update-team-user.component";
import { MatDialogModule } from "@angular/material/dialog";
import { FaqComponent } from "./customer-mgmt/faq/faq.component";
import { MatExpansionModule } from "@angular/material/expansion";
import { ChartsModule } from "ng2-charts";
import { MatMenuModule } from "@angular/material/menu";
import { MatButtonModule } from "@angular/material/button";
import { DrivingSchoolProfileComponent } from "./driving-school/driving-school-profile/driving-school-profile.component";
import { MatCardModule } from "@angular/material/card";
import { MatInputModule } from "@angular/material/input";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgxMaskModule } from "ngx-mask";
import { DrivingSchoolMyEarningsComponent } from "./driving-school/driving-school-my-earnings/driving-school-my-earnings.component";
import { MatTabsModule } from "@angular/material/tabs";
import { DrivingSchoolReferralsComponent } from "./driving-school/driving-school-my-earnings/driving-school-referrals/driving-school-referrals.component";
import { DrivingSchoolCommissionEarningsComponent } from "./driving-school/driving-school-my-earnings/driving-school-commission-earnings/driving-school-commission-earnings.component";
import { DrivingSchoolStudentsComponent } from "./driving-school/driving-school-students/driving-school-students.component";
import { DrivingSchoolDashboardComponent } from "./driving-school/driving-school-dashboard/driving-school-dashboard.component";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { ClipboardModule } from "@angular/cdk/clipboard";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 0.3,
};
import { DsSlotBookingComponent } from "./driving-school/ds-slot-booking/ds-slot-booking.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { TripsMapComponent } from "./customer-mgmt/trips/trips-map/trips-map.component";
import { AgmCoreModule } from "@agm/core";
import { AgmDirectionModule } from "agm-direction";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { MapDashboardComponent } from "./fleet/map-dashboard/map-dashboard.component";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatIconModule } from "@angular/material/icon";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDividerModule } from "@angular/material/divider";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { AgmDrawingModule } from "@agm/drawing";
import { ConfirmDialogComponent } from "./fleet/map-dashboard/confirm-dialog/confirm-dialog.component";
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { SocketIoService } from "../services/socket-io.service";
import { DriverRiskAnalysisComponent } from "./fleet/driver-risk-analysis/driver-risk-analysis.component";
import { SharedModule } from "../shared/shared.module";
import { DrivingAlertsAnalysisComponent } from "./fleet/driver-risk-analysis/driving-alerts-analysis/driving-alerts-analysis.component";
import { AllVehiclesComponent } from "./all-vehicles/all-vehicles.component";
import { DeviceStatusDialogComponent } from "./fleet/device-status-dialog/device-status-dialog.component";
import { FuelExpensesComponent } from "./fleet/fuel-expenses/fuel-expenses.component";

@NgModule({
  declarations: [
    DashboardComponent,
    CalendarComponent,
    ChatComponent,
    KanbanComponent,
    VehiclesComponent,
    TripsComponent,
    DrivingAlertsComponent,
    VehicleTroubleCodesComponent,
    AlertCustomersComponent,
    RemindersUsersComponent,
    TeamUsersComponent,
    AddUpdateTeamUserComponent,
    FaqComponent,
    DrivingSchoolProfileComponent,
    DrivingSchoolMyEarningsComponent,
    DrivingSchoolReferralsComponent,
    DrivingSchoolCommissionEarningsComponent,
    DrivingSchoolStudentsComponent,
    DrivingSchoolDashboardComponent,
    DsSlotBookingComponent,
    TripsMapComponent,
    MapDashboardComponent,
    ConfirmDialogComponent,
    DriverRiskAnalysisComponent,
    FuelExpensesComponent,
    DrivingAlertsAnalysisComponent,
    AllVehiclesComponent,
    DeviceStatusDialogComponent,
    FuelExpensesComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PagesRoutingModule,
    UiModule,
    UIModule,
    Ng2SearchPipeModule,
    NgbNavModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgApexchartsModule,
    PerfectScrollbarModule,
    DndModule,
    FullCalendarModule,
    EcommerceModule,
    EmailModule,
    IconsModule,
    ChartModule,
    FormModule,
    TablesModule,
    MapsModule,
    LeafletModule,
    WidgetModule,
    AlertModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDialogModule,
    MatExpansionModule,
    ChartsModule,
    MatMenuModule,
    MatButtonModule,
    MatCardModule,
    MatInputModule,
    MatTooltipModule,
    NgxMaskModule,
    MatTabsModule,
    NgMultiSelectDropDownModule,
    ClipboardModule,
    NgSelectModule,
    AgmCoreModule,
    AgmDirectionModule,
    DragDropModule,
    NgxDaterangepickerMd,
    MatButtonToggleModule,
    MatIconModule,
    MatCheckboxModule,
    MatDividerModule,
    MatDatepickerModule,
    NgbCollapseModule,
    AgmDrawingModule,
    NgxSpinnerModule,
    SharedModule,
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    DashboardService,
    SocketIoService,
    NgxSpinnerService,
    AlertService,
  ],
  entryComponents: [AddUpdateTeamUserComponent, ConfirmDialogComponent],
})
export class PagesModule {}
